<template>
  <q-page padding class="column items-center justify-start ">
    <div class="col-12 full-width ">
      <h4 class="q-my-md">Настройки пользователя</h4>
    </div>
    <div class="col-12 full-width ">
      <q-card>
        <q-form @submit.prevent="update">
          <q-card-section>
            <div class="text-h6">Сменить пароль</div>
          </q-card-section>


          <q-card-section class="q-pt-none">
            <q-input dense v-model="updatePassword.oldPassword" type="password" label="Старый пароль"
                     :rules="[requiredRule]"/>
            <q-input dense v-model="updatePassword.password" type="password" label="Новый пароль"
                     :rules="[requiredRule, passwordRule]"/>
            <q-input dense v-model="confirmPassword" type="password" label="Подтвердить новый пароль"
                     :rules="confirmPasswordRules"/>
          </q-card-section>

          <q-card-actions align="right" class="text-primary">
            <q-btn no-caps flat label="Обновить" type="submit"/>
          </q-card-actions>
        </q-form>
      </q-card>
    </div>
  </q-page>
</template>

<script setup lang="ts">
import {reactive, ref} from "vue";
import {UpdatePasswordRequest} from "../../models/auth";
import {passwordRule, requiredRule} from "../../util/rules";
import {useUpdatePassword} from "../../composables/auth";
import {useQuasar} from "quasar";
import {computedEager} from "@vueuse/core";

const $q = useQuasar()

const updatePassword = reactive<UpdatePasswordRequest>({
  oldPassword: '',
  password: ''
})
const confirmPassword = ref('')

const {execute} = useUpdatePassword(updatePassword)


const confirmPasswordRules = computedEager(() => {
  const rule = (v: string) => (v === updatePassword.password) || "Пароли не совпадают"
  return [requiredRule, rule]
})


async function update() {
  await execute(true)
  $q.dialog({
    title: "Обновление",
    message: "Пароль был обновлен"
  })

}
</script>

<style scoped>

</style>